export default __webpack_public_path__ + "static/media/error.183e5da9.svg";